<div class="filter-container">
  <div class="filter-label">
    <label>Begins with</label>
  </div>
  <input 
    type="text"
    [(ngModel)]="filterText"
    (keyup.enter)="onApply()"
    [disabled]="isGridLoading()"
    placeholder="Min 3 characters..."
    class="filter-input"
  />
  <div class="button-container">
    <button 
      (click)="onApply()" 
      [disabled]="!canApply()"
      [class.disabled]="!canApply()"
      [class.loading]="isGridLoading()"
      class="apply-button">
      <span *ngIf="!isGridLoading()">Apply</span>
      <span *ngIf="isGridLoading()">Loading...</span>
    </button>
  </div>
  <div *ngIf="filterText && !canApply() && !isGridLoading()" class="error-message">
    Enter at least 3 characters
  </div>
</div>